import { Connection1cFindDto, type Connection1cFindInterface } from '@zaoblako/shared/modules/integration/dtos/connection-1c/connection-1c-find.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { CatalogDtosKeysEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-dtos-keys.enum';

import * as yup from 'yup';

/** Accounting subaccount response body - DTO signature */
export interface AccountingSubAccountFindInterface {
  /** Unique identifier. Cannot be changed. */
  id: number;
  /** Sub-account creation date and type */
  created: Date;
  /** Sub-account last update date and type */
  updated: Date;
  /** Sub-account soft deletion date and type */
  deleted?: Date;
  /** Sub-account name */
  name: string;
  /** Is only turnovers accounting */
  onlyTurnovers?: boolean;
  /** Is summative sub-account? */
  summative?: boolean;
  /** Is currency sub-account? */
  currency?: boolean;
  /** Is quantitative sub-account? */
  quantitative?: boolean;
  /** 1C ERP databases that use this sub-account */
  connections?: Connection1cFindInterface[];
}

/** Accounting subaccount response body - DTO schema */
export const AccountingSubAccountFindDto = SerdeDtoClass.create<AccountingSubAccountFindInterface>(CatalogDtosKeysEnum.ACCOUNTING_SUB_ACCOUNT_FIND_DTO, {
  id: {
    sortable: true,
    label: 'Номер',
    serializer: yup.number(),
  },
  created: {
    label: 'Создан',
    serializer: yup.date()
  },
  updated: {
    label: 'Изменен',
    serializer: yup.date()
  },
  deleted: {
    optional: true,
    label: 'Удален',
    serializer: yup.date()
  },
  name: {
    sortable: true,
    label: 'Наименование',
    serializer: yup.string(),
  },
  onlyTurnovers: {
    optional: true,
    label: 'Только обороты',
    serializer: yup.boolean(),
  },
  summative: {
    optional: true,
    label: 'Суммовой',
    serializer: yup.boolean(),
  },
  currency: {
    optional: true,
    label: 'Валютный',
    serializer: yup.boolean(),
  },
  quantitative: {
    optional: true,
    label: 'Количественный',
    serializer: yup.boolean(),
  },
  connections: {
    optional: true,
    label: 'В каких базах 1С используется',
    nested: Connection1cFindDto,
    serializer: (_, nested) => yup.array(nested),
  },
});
